module.exports = __webpack_public_path__ + "static/media/ck1.64323a1e.jpg";